export default "__VITE_ASSET__DbqXal6h__"